/* =============================================
   4YOU OUTLET — PREMIUM UPGRADE JS
   ============================================= */

(function() {
  'use strict';

  /* --- Scroll-to-top offset when stickyCart visible --- */
  function initScrollTopOffset() {
    var scrollBtn = document.getElementById('site-scroll');
    if (!scrollBtn) return;
    var observer = new MutationObserver(function() {
      var sticky = document.querySelector('.stickyCart');
      if (sticky && sticky.style.display !== 'none') {
        scrollBtn.style.bottom = '90px';
      } else {
        scrollBtn.style.bottom = '';
      }
    });
    var sticky = document.querySelector('.stickyCart');
    if (sticky) {
      observer.observe(sticky, { attributes: true, attributeFilter: ['style'] });
    }
  }

  /* --- Cart Badge Bounce on Add --- */
  function initCartBadgeBounce() {
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.add-to-cart, .addToCart, .product-form__submit')) return;
      setTimeout(function() {
        var badge = document.querySelector('.cartCount');
        if (badge) {
          badge.classList.remove('cart-badge-bounce');
          // Force reflow
          void badge.offsetWidth;
          badge.classList.add('cart-badge-bounce');
        }
      }, 600);
    });
  }

  /* --- Search Overlay (Enhanced) --- */
  function initSearchOverlay() {
    var searchIcons = document.querySelectorAll('.searchIco, .header__search-btn, [data-search-toggle]');
    if (!searchIcons.length) return;

    // Check if overlay already exists
    if (document.getElementById('premiumSearchOverlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'premiumSearchOverlay';
    overlay.className = 'premium-search-overlay';
    overlay.innerHTML = '<div class="premium-search-inner">' +
      '<button class="premium-search-close" aria-label="Close">&times;</button>' +
      '<form action="/search" method="get" class="premium-search-form">' +
        '<input type="hidden" name="type" value="product">' +
        '<input type="search" name="q" placeholder="Cauta produse..." class="premium-search-input" autocomplete="off">' +
      '</form>' +
      '<div class="premium-search-results"></div>' +
    '</div>';

    document.body.appendChild(overlay);

    var input = overlay.querySelector('.premium-search-input');
    var closeBtn = overlay.querySelector('.premium-search-close');
    var results = overlay.querySelector('.premium-search-results');

    searchIcons.forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        overlay.classList.add('active');
        setTimeout(function() { input.focus(); }, 100);
      });
    });

    function closeOverlay() {
      overlay.classList.remove('active');
      input.value = '';
      results.innerHTML = '';
    }

    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeOverlay();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) closeOverlay();
    });

    // Predictive search
    var searchTimeout;
    input.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      var term = input.value.trim();
      if (term.length < 3) { results.innerHTML = ''; return; }
      searchTimeout = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            if (!products.length) {
              results.innerHTML = '<p class="premium-search-empty">Niciun rezultat</p>';
              return;
            }
            results.innerHTML = products.map(function(p) {
              return '<a href="' + p.url + '" class="premium-search-item">' +
                '<img src="' + (p.image || '') + '" alt="" class="premium-search-item-img" loading="lazy">' +
                '<div class="premium-search-item-info">' +
                  '<span class="premium-search-item-title">' + p.title + '</span>' +
                  '<span class="premium-search-item-price">' + (p.price || '') + '</span>' +
                '</div>' +
              '</a>';
            }).join('');
          })
          .catch(function() {});
      }, 300);
    });
  }

  /* --- Auto-select "In Stock" filter, hide from UI, persist on clear --- */
  function initPersistentStockFilter() {
    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;

    // Find availability param name & value from form
    var availParam = null, availValue = null;
    form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      var name = cb.getAttribute('name') || '';
      var val = cb.getAttribute('value') || '';
      if (name.toLowerCase().indexOf('availability') !== -1 &&
          (val === '1' || val.toLowerCase() === 'true' || val.toLowerCase().indexOf('stock') !== -1 || val.toLowerCase().indexOf('stoc') !== -1)) {
        availParam = name;
        availValue = val;
      }
    });
    if (!availParam) return;

    // If availability not in URL, redirect once to apply it (CSS handles hiding)
    if (window.location.search.indexOf('availability') === -1) {
      var url = new URL(window.location.href);
      url.searchParams.set(availParam, availValue);
      window.location.replace(url.toString());
      return;
    }

    // Intercept "Clear All" to preserve availability
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a.actFilter');
      if (!link) return;
      var text = (link.textContent || '').toLowerCase();
      var isClearAll = text.indexOf('ster') !== -1 || text.indexOf('clear') !== -1;
      if (!isClearAll) return;

      e.preventDefault();
      e.stopPropagation();
      var url = new URL(link.getAttribute('href') || '', window.location.origin);
      url.searchParams.set(availParam, availValue);
      window.location.href = url.toString();
    }, true);
  }

  /* --- Cart quantity max stock message --- */
  function initCartQuantityMessage() {
    // Override the auto-hide timeout for error messages in cart drawer
    // Theme.js hides errors after 1 second — we make them persist longer and style them

    // Watch for error messages appearing in cart
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var target = mutation.target;
        if (target.classList && target.classList.contains('ctItem-error') && target.innerHTML.trim()) {
          // Error message appeared — make it more visible
          var errorContainer = target.closest('.ermsg');
          if (errorContainer) {
            errorContainer.classList.add('stock-limit-visible');
            // Auto-hide after 5 seconds (instead of theme's 1 second)
            setTimeout(function() {
              errorContainer.classList.remove('stock-limit-visible');
            }, 5000);
          }
        }
      });
    });

    // Observe all potential error containers in cart drawer
    function observeCartErrors() {
      document.querySelectorAll('.ctItem-error').forEach(function(el) {
        observer.observe(el, { childList: true, characterData: true, subtree: true });
      });
    }

    // Run initially and after cart updates
    observeCartErrors();

    // Re-observe when cart drawer content changes
    var cartDrawer = document.querySelector('cart-drawer-items, .cart-drawer');
    if (cartDrawer) {
      new MutationObserver(function() {
        setTimeout(observeCartErrors, 200);
      }).observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  /* --- Active nav underline on current page --- */
  function initActiveNav() {
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    var navLinks = document.querySelectorAll('#siteNav > li.lvl1 > a');

    navLinks.forEach(function(link) {
      var href = (link.getAttribute('href') || '').replace(/\/$/, '') || '/';

      // Match exact path or child path (e.g. /collections/femei matches when on /collections/femei/something)
      var isActive = false;
      if (href === '/' && currentPath === '/') {
        isActive = true;
      } else if (href !== '/' && href !== '#' && currentPath.indexOf(href) === 0) {
        isActive = true;
      }

      if (isActive) {
        link.parentElement.classList.add('active');
      }
    });
  }

  /* --- Init all on DOMContentLoaded --- */
  function init() {
    initScrollTopOffset();
    initCartBadgeBounce();
    initSearchOverlay();
    initPersistentStockFilter();
    initCartQuantityMessage();
    initActiveNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
